<template>
  <div class="contact">
    <div class="detail-box">
      <div class="title">联系我们</div>
      <div class="english">Contact us</div>
      <div class="out-box">
        <div class="detail">
          <span>联系电话：</span>
          <span>{{contactForm.phone}}</span>
        </div>
        <div class="detail" style="margin-left:20px;margin-right:20px;">
          <span>Email：</span>
          <span>{{contactForm.email}}</span>
        </div>
        <div class="detail">
          <span>地址：</span>
          <span>{{contactForm.address}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import schoolApi from "@/api/school";
import areaApi from "@/api/area";
import { getStorage } from "@/common/js/localstorage";

export default {
  name: "Contact",
  data() {
    return {
      schoolId: 0,
      areaId: 0,
      isSchool: true,
      contactForm: {}
    }
  },
  created() {
    this.getSchoolId();
  },
  mounted() {
    if (this.isSchool) {
      this.getSchoolSetting();
    } else {
      this.getAreaSetting();
    }
  },
  methods: {
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      if (getStorage("user")) {
        let data = getStorage("user");
        if (data.area_type == 2) {
          this.schoolId = data.area_id;
          this.isSchool = true;
        } else {
          this.areaId = data.area_id;
          this.isSchool = false;
        }
      } else {
        if (getStorage("school")) {
          let data = getStorage("school");
          if (data.org_type == 2) {
            this.schoolId = data.org_id;
            this.isSchool = true;
          } else {
            this.areaId = data.org_id;
            this.isSchool = false;
          }
        }
      }
    },
    // 获取学校设置信息
    getSchoolSetting() {
      schoolApi.getSchoolSetting(this.schoolId).then((response) => {
        if (response.data.status == 0) {
          this.contactForm = response.data.data;
        } else {
          console.log(response.data.info.detail);
          this.$message({
            type: "warning",
            message: response.data.info.message,
          });
        }
      });
    },
    // 获取区域设置信息
    getAreaSetting() {
      areaApi.getAreaSetting(this.areaId).then((response) => {
        if (response.data.status == 0) {
          this.contactForm = response.data.data;
        } else {
          console.log(response.data.info.detail);
          this.$message({
            type: "warning",
            message: response.data.info.message,
          });
        }
      });
    }
  }
}
</script>

<style scoped lang="stylus">
.contact {
  width: 100%;
  min-height: calc(100vh - 144px);
  display: flex;
  justify-content: center;
  align-items: center;

  .detail-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
    padding-bottom: 80px;
    box-sizing: border-box;

    .title {
      font-size: 24px;
      font-weight: bold;
    }

    .english {
      color: #9A9A9A;
      margin-top: 20px;
      margin-bottom: 40px;
    }

    .out-box {
      width: 100%;
      display: flex;
      justify-content: center;

      .detail {
        border: 1px solid #E7E7E7;
        padding: 20px;
        border-radius: 10px;
        color: #343434;
      }
    }
  }
}
</style>